exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tree-view-item-node .tree-view-item-key {\n    color: #333 !important;\n}\n.tree-view-item-key {\n    color: #b300ff;\n}\n", ""]);

// exports
